import * as React from 'react';
import { errorText } from '../app/context';

/** Loads something once (and again on reload or when deps change), with its error in plain words. */
export function useLoad<T>(load: () => Promise<T>, deps: React.DependencyList): { data: T | undefined; error: string | undefined; reload: () => void } {
  const [data, setData] = React.useState<T | undefined>(undefined);
  const [error, setError] = React.useState<string | undefined>(undefined);
  const [tick, setTick] = React.useState<number>(0);
  React.useEffect(() => {
    let live: boolean = true;
    setError(undefined);
    load().then(d => { if (live) { setData(d); } }).catch(e => { if (live) { setError(errorText(e)); } });
    return () => { live = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, tick]);
  return { data, error, reload: () => setTick(t => t + 1) };
}
